import { render, staticRenderFns } from "./pass-dialog.vue?vue&type=template&id=982ec27c"
import script from "./pass-dialog.vue?vue&type=script&lang=js"
export * from "./pass-dialog.vue?vue&type=script&lang=js"
import style0 from "./pass-dialog.vue?vue&type=style&index=0&id=982ec27c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports